import React from "react";
import { useNavigation } from "../../../hooks";
import { Button } from "../../catalyst/button";
import Icon from "../../ui/Icon";

const AuthSelectionScreen: React.FC = () => {
  const { goBack, navigateToPhoneAuth } = useNavigation();

  return (
    <div className="h-screen-dvh bg-bg-background flex flex-col">
      {/* 상단 헤더 */}
      <header className="bg-white px-4 py-3 flex items-center border-b border-border-default">
        <button
          onClick={goBack}
          className="flex items-center justify-center w-8 h-8 mr-3 hover:bg-gray-100 rounded-full transition-colors"
        >
          <Icon name="chevronLeft" className="text-text-secondary" />
        </button>
        <h1 className="text-l font-medium text-text-primary">
          로그인 및 회원가입
        </h1>
      </header>

      {/* 메인 콘텐츠 */}
      <main className="flex-1 flex flex-col px-6 py-8 justify-center">
        <div className="text-center mb-8">
          <h2 className="text-xxl font-semibold text-text-primary mb-4">
            홈닥터 AI에 오신 것을 환영합니다
          </h2>
          <p className="text-text-secondary text-m leading-relaxed mb-8">
            간편한 본인 인증으로 시작해보세요.
            <br />
            인증 완료 후 자동으로 로그인 또는 회원가입이 진행됩니다.
          </p>
        </div>

        <div className="max-w-sm mx-auto w-full">
          <Button
            color="blue"
            className="w-full py-4 text-l"
            onClick={navigateToPhoneAuth}
          >
            <span className="font-medium">본인 인증으로 시작하기</span>
          </Button>
        </div>
      </main>
    </div>
  );
};

export default AuthSelectionScreen;
